import { customerContactQuery } from "@common/api/customers"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { ContactEditForm } from "@/routes/_layout/customer_/$customerId/contacts/-components/form/contact-edit-form"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/contacts/_list/$contactId",
)({
  loader: ({ context: { queryClient }, params: { contactId } }) =>
    queryClient.fetchQuery(customerContactQuery({ contact_id: contactId })),
  staticData: { detailSidebar: true },
  component: ContactPanel,
})

function ContactPanel(): React.ReactElement {
  const { customerId, contactId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const { data: contact } = useSuspenseQuery(
    customerContactQuery({ contact_id: contactId }),
  )
  const close = () =>
    navigate({
      to: "/customer/$customerId/contacts",
      params: { customerId },
      search: true,
    })

  return (
    <ContactEditForm
      key={`${contact.id}-${contact.archived_at}`}
      contact={contact}
      onClose={close}
      onRestore={() => showToast("Restored", "Record restored.", "success")}
      onSave={(saved) =>
        showToast(
          "Saved",
          `${saved.first_name} ${saved.last_name} updated.`,
          "success",
        )
      }
    >
      <Outlet />
    </ContactEditForm>
  )
}
